import { get } from 'lodash';

export const selectHeadbandState = state => get(state, 'headband');
